<template>
  <ExternalList
      endpoint="/api/v2/commission-items"
      :endpoint-filters="{user_id: user.id}"
      :headlines="headlines"
      :can-update="() => true"
      :can-destroy="() => true"
      :checkbox-column-width="1"
      :button-column-width="2"
      @show="commissionItem => edit(commissionItem)"
  >
    <template v-slot:default="{ row: commissionItem }">
      <td class="table__ellipsis">
        {{ commissionItem.attributes.commission_description }}
      </td>

      <td class="table__ellipsis">
        {{ commissionItem.attributes.customer_name }}
      </td>

      <td>
        {{ commissionItem.attributes.value | price }}
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal
          :user="user"
          @created="load"
      />

      <EditModal
          :commission-item="editing"
          @updated="update"
      />
    </template>
  </ExternalList>
</template>

<script>
import CreateModal from '@/components/Modals/Administration/Authentication/CommissionItems/Create'
import EditModal from '@/components/Modals/Administration/Authentication/CommissionItems/Edit'
import ExternalList from "@/components/Panels/Lists/External";

export default {
  components: {
    CreateModal,
    EditModal,
    ExternalList,
  },

  props: {
    user: {
      required: true
    }
  },

  data() {
    return{
      editing: null,
    }
  },

  computed: {
    headlines() {
      return [
        {width: 9, text: 'Description', },
        {width: 8, text: 'Customer'},
        {width: 4, text: 'Value'},
      ]
    },
  },

  methods:{
    edit(commissionItem) {
      this.editing = commissionItem

      $("#edit-commission-item-modal").modal('show')
    },
  }
}
</script>
